export const CycleSituation = {
  Closed: 'E',
  Active: 'V',
  Upcoming: 'N',
} as const;

export const CycleSituationFullTerm = {
  [CycleSituation.Active]: 'VIGENTE',
} as const;

export const CycleSituationTerm = {
  [CycleSituation.Closed]: 'Encerrado',
  [CycleSituation.Active]: 'Vigente',
  [CycleSituation.Upcoming]: 'Não Iniciado',
} as const;

export type CycleSituationKey = keyof typeof CycleSituation;

export type CycleSituationModel = (typeof CycleSituation)[CycleSituationKey];

export interface CycleComboModel {
  id: number;
  anoCiclo: number;
  situacao: string;
  nome: string;
}

export function cycleSituationTerm(cycleSituation?: CycleSituationModel) {
  return cycleSituation ? CycleSituationTerm[cycleSituation] : '';
}

export function cycleComboDataToValues(data?: CycleComboModel[]) {
  return (
    data?.map((item) => ({
      id: item.id,
      label: item.anoCiclo + ' - ' + item.nome,
    })) ?? []
  );
}

export function isCycleActive(cycle?: CycleComboModel) {
  return cycle?.situacao === CycleSituationFullTerm[CycleSituation.Active];
}

export function cycleComboDataToInitialSelectedValuesId(
  data?: CycleComboModel[],
) {
  const actives = data?.filter((item) => item.situacao === 'VIGENTE');
  return actives?.map((item) => item.id) ?? [];
}
